export const profilerJobDetailData = {
    mainJob: {
      title: 'Site Area Safety Supervisor',
      company: 'LAFARGE Biskra',
      id: 'JDO121342',
      postedOn: '2 days ago',
      location: 'India',
      experience: '4+ years',
      vacancies: '2',
      status: 'Permanent',
      industry: 'Cement',
      deadline: '25-Jul-2025',
      deadlineCountdown: '2 Days to go',
      category: 'Construction',
      languages: ['English', 'French'],
      skills: ['React', 'Node Js'],
      requirements: [
        'Reliable and accurate in feedback to hierarchy',
        'Practical knowledge of energy isolation (low/high voltage) – project without electrical supervisor',
        'Good understanding of technical safety aspects',
        'Familiar with erection/construction processes',
        'Strong communication skills and principled approach',
      ],
      responsibilities: [
        'Lead and coach the safety crew',
        'Conduct risk assessments and ensure PTW matches site activity',
        'Enforce safety rules and follow-up on remedial actions',
        'Perform regular safety inspections and site tours',
        'Stay updated on all safety aspects on-site',
      ],
      objectives: [
        'Ensure contractors enforce all site safety requirements',
        'Validate that permit-to-work aligns with actual site tasks',
        'Implement Lafarge Group safety standards',
        'Maintain site hygiene and cleanliness',
      ],
    },
    otherJobs: [
      { id: 1, title: 'Frontend Developer – Angular', company: 'TechNova Solutions – Bangalore, India', jobId: 'JDO121342', postedOn: '2 days ago', location: 'India', experience: '4-6 years', vacancies: 2, deadline: '27-Jul-2025', skills: ['React', 'JavaScript', 'Node.js', 'TypeScript'] },
      { id: 2, title: 'Full Stack Engineer – MERN Stack', company: 'CloudBridge Pvt. Ltd. – Pune, India', jobId: 'JDO121342', postedOn: '5 days ago', location: 'India', experience: '4+ years', vacancies: 1, deadline: '29-Jul-2025', skills: ['React', 'JavaScript', 'Node.js', 'TypeScript'] },
      { id: 3, title: 'Construction Safety Officer', company: 'Reliance Infrastructure – Hyderabad, India', jobId: 'JDO567890', postedOn: '2 days ago', location: 'India', experience: '5+ years', vacancies: 3, deadline: '29-Jul-2025', skills: ['Safety', 'OSHA'] },
    ],
  };